import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    p: 2,
    backgroundColor: theme.palette.background.default,
  },
  gridContainer: {
    maxWidth: 1200,
    mt: theme.spacing(2),
  },
  card: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    p: 2,
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    mb: theme.spacing(2),
  },
  image: {
    width: 60,
    height: 60,
    borderRadius: 8,
  },
  title: {
    fontWeight: 'bold',
  },
  priceContainer: {
    mt: 2,
  },
  originalPrice: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary,
    mb: 1,
  },
  promotionalPrice: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    mt: theme.spacing(1),
  },
  iconButton: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '50%',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteButton: {
    ml: theme.spacing(2),
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
  },
  summaryContainer: {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  summaryTitle: {
    fontWeight: 'bold',
  },
  calculateText: {
    color: theme.palette.text.secondary,
  },
  advanceButton: {
    mt: 2,
    width: '100%',
  },
});
